import { getRandomNum, lastSevenDayData } from "@/utils/index.js";

export function workerData() {
  return [
    {
      "name": "支护工",
      "id": 428,
      "value": 6
    },
    {
      "name": "钢筋工",
      "id": 431,
      "value": 4
    }
  ]

}


export function StatisticsData() {
  let dataDom = [];

  lastSevenDayData().forEach(itemDate => {
    dataDom.push({
      date: itemDate.startTime,
      value: getRandomNum(0, 40)
    })
  })

  return dataDom;

}


const gasData = [
  { "tunnelNumber": "null", "gasName": "氧气", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "一氧化碳", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "可燃气体", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "硫化氢", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "温度", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "湿度", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "甲烷", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "二氧化氮", "avgArray": "" },
  { "tunnelNumber": "null", "gasName": "二氧化碳", "avgArray": "" }
];

// 生成指定长度的随机数数组（根据当前小时数）
export function generateAvgArrayForGasData() {
   // 获取当前小时（0-23），模拟当前是9点，实际使用时可改为 new Date().getHours()
  const currentHour = new Date().getHours(); // 实际场景用：new Date().getHours()
  const arrayLength = currentHour > 0 ? currentHour : 0; // 小时数为0时生成空数组
  
  // 每种气体的合理数值范围（基于实际检测场景）
  const gasRanges = {
    "氧气": [21.5, 22.5], // 正常氧气浓度（%）
    "一氧化碳": [0, 1], // 安全范围扩展（mg/m³）
    "可燃气体": [0, 1], // 可燃气体检测范围（ppm）
    "硫化氢": [0, 0], // 安全范围（ppm）
    "温度": [13, 15], // 环境温度（℃）
    "湿度": [60, 67], // 相对湿度（%RH）
    "甲烷": [0, 0], // 甲烷检测范围（ppm）
    "二氧化氮": [0, 1], // 安全范围（ppm）
    "二氧化碳": [0, 10] // 正常空气范围（ppm）
  };
  
  // 处理每个气体数据
  gasData.forEach(gas => {
    const [min, max] = gasRanges[gas.gasName];
    const arr = [];
    
    // 生成对应长度的数值数组（保留2位小数精度）
    for (let i = 0; i < arrayLength; i++) {
      // 生成范围内的随机数，保留2位小数（使用Number确保是数值类型）
      const randomNum = Number((Math.random() * (max - min) + min).toFixed(2));
      arr.push(randomNum);
    }
    
    // 直接赋值为数组（不再是字符串）
    gas.avgArray = arr;
  });
  
  return gasData;
}
